(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/search-results/search-results-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/search-results/search-results-list.js');
'use strict';

const {
  ListGroup
} = svs.ui.ReactListGroup;
const {
  useHistory
} = ReactRouterDOM;
const ResultItem = svs.grassroots.components.search_results.ResultItem;
const ReceiverBottomSheet = svs.grassroots.components.receiver.ReceiverBottomSheet;
const SearchResultsList = _ref => {
  let {
    resultPage,
    receivers,
    searchterm
  } = _ref;
  const [open, setOpen] = React.useState(false);
  const [receiver, setReceiver] = React.useState(false);
  const history = useHistory();

  const onOpenBottomSheetHandler = (receiver, event) => {
    event.preventDefault();
    event.stopPropagation();
    setReceiver(receiver);
    setOpen(true);
    if (!resultPage) {
      window.history.replaceState(null, null, "".concat(svs.core.data.baseUrl, "/forening/").concat(receiver.id));
    }
  };

  const onCloseBottomSheetHandler = () => {
    setOpen(false);
    setReceiver({});
    if (!resultPage) {
      history.replace("/sok?q=".concat(encodeURIComponent(searchterm)));
    }
  };
  return React.createElement("div", null, open && React.createElement(ReceiverBottomSheet, {
    close: onCloseBottomSheetHandler,
    isOpen: open,
    receiver: receiver
  }), React.createElement(ListGroup, null, receivers.map(receiver => React.createElement(ResultItem, {
    key: receiver.id,
    onClick: onOpenBottomSheetHandler,
    receiver: receiver
  }))));
};
svs.grassroots.components.search_results.SearchResultsList = SearchResultsList;

 })(window);